// A ‘.tsx’ file enables JSX support in the TypeScript compiler, 
// for more information see the following page on the TypeScript wiki:
// https://github.com/Microsoft/TypeScript/wiki/JSX

import React from 'react';
import SystemStore from './../../stores/SystemStore';
interface ActionInProgressLoaderProps extends OptionalHtmlProps {
    actionKey: string[];
}

interface ActionInProgressState {
    isActionInProgress: boolean;
}

function getState(actionKey: string[]) {
    var actionInProgress = false;
    for (var i = 0; i < actionKey.length; i++) {
        if (SystemStore.isActionInProgress(actionKey[i])) {
            actionInProgress = true;
        }
    }
    return {
        isActionInProgress: actionInProgress
    }
}

class ActionInProgressLoader extends React.Component<ActionInProgressLoaderProps, ActionInProgressState> {

    constructor(props: ActionInProgressLoaderProps) {
        super(props);
        this.state = getState(props.actionKey);
    }

    private _onChange = () => {
        this.setState(getState(this.props.actionKey));
    }

    componentDidMount() {
        SystemStore.addChangeListener(this._onChange);
    }

    componentWillUnmount() {
        SystemStore.removeChangeListener(this._onChange);
    }

    render(): any {
        return (this.state.isActionInProgress ? <div style={this.props.styles} className={this.props.class}>{this.props.children}</div> : false);
    }
}


export default ActionInProgressLoader;